import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';

export default function CustomerItem({ customerDesc, history, showLeadStageBadge = false }) {
    const onClickItem = useCallback(() => {
        history.push('/customers/' + customerDesc.id);
    }, [history, customerDesc.id]);

    const leadStageLabel = customerDesc.leadStageLabel || null;

    return (
        <div>
            <div
                className="location-item"
                onClick={onClickItem}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    width: '100%',
                    boxSizing: 'border-box',
                    padding: '0.25rem 1rem',
                    cursor: 'pointer',
                    overflowWrap: 'break-word',
                    whiteSpace: 'normal',
                }}>
                <span style={{ flex: 1, minWidth: 0 }}>{customerDesc.name}</span>
                {showLeadStageBadge && leadStageLabel && (
                    <Chip label={leadStageLabel} size="small" variant="outlined" sx={{ ml: 'auto' }} />
                )}
            </div>
        </div>
    );
}

CustomerItem.propTypes = {
    customerDesc: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string,
        leadStage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
    history: PropTypes.object.isRequired,
    showLeadStageBadge: PropTypes.bool,
};
